import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule, provideZoneChangeDetection } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
import { TokenInterceptor, ErrorInterceptor } from '@core/interceptors';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MAT_INPUT_CONFIG } from '@angular/material/input';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule({
  declarations: [AppComponent],
  exports: [MatDialogModule, ReactiveFormsModule, FormsModule, MatSelectModule],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    GraphQLModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    MatDialogModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection(),
  ],
})
export class AppModule {
  private icons = [
    'question_check',
    'circle_check_mark',
    'question_rejected',
    'question_que',
    'navbar_arrow',
    'game_base',
    'game_ready',
    'game_standard',
    'game_special',
    'game_private',
    'app_arrow_left',
    'app_out',
    'pdf_icon',
    'app_flag_outlined',
    'app_camera',
    'app_trash',
    'app_picture',
    'app_upload',
    'app_download',
    'app_eye',
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
    this.icons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `/assets/svg/${icon}.svg`,
        ),
      );
    });
  }
}
